exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vcp-dashboard{z-index:11;position:absolute;left:0;bottom:0;width:100%;height:59px;background:rgba(0,0,0,.5)}.fullscreen .vcp-dashboard{bottom:60px;width:1182px;left:50%;margin-left:-591px}.small .vcp-dashboard{height:49px}.settings-open .vcp-dashboard{display:block!important}.small .vcp-dashboard .vcp-controls{height:40px}", ""]);

// exports
